export const ChurnOptions = [
	{ id: "費用面", value: "費用面", label: "費用面" },
	{ id: "操作が難しい", value: "操作が難しい", label: "操作が難しい" },
	{ id: "運営体制とのミスマッチ", value: "運営体制とのミスマッチ", label: "運営体制とのミスマッチ" },
	{ id: "トライアル利用のため", value: "トライアル利用のため", label: "トライアル利用のため" },
	{ id: "一時休館", value: "一時休館", label: "一時休館" },
	{ id: "運営会社変更", value: "運営会社変更", label: "運営会社変更" },
	{ id: "閉業", value: "閉業", label: "閉業" },
	{ id: "自社集客困難", value: "自社集客困難", label: "自社集客困難" },
	{ id: "他の予約システムへ乗り換え", value: "他の予約システムへ乗り換え", label: "他の予約システムへ乗り換え" },
	{ id: "その他", value: "その他", label: "その他" },
];
